import React, { useState } from "react";
import { AiFillTikTok, AiOutlineMail, AiOutlineSend } from "react-icons/ai";
// import { FiPhoneCall } from "react-icons/fi";
import TextField from "@mui/material/TextField";

import {
  FaFacebookSquare,
  FaInstagram,
  FaLinkedin,
  FaTelegram,
  FaTwitter,
} from "react-icons/fa";
import { contactUs } from "../../redux/templete/authSlice";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { TiSocialYoutube } from "react-icons/ti";

function ContactUsCard() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [userMessage, setUserMessage] = useState("");

  const dispatch = useDispatch();
  function formSubmit() {
    let userData = { name, email, message: userMessage };
    if (userMessage) {
      dispatch(contactUs(userData));
      setName("");
      setEmail("");
      setUserMessage("");
    } else {
      toast.error("Message is required.");
    }
  }

  return (
    <div className="flex flex-row max-sm:flex-col max-md:flex-col max-lg:flex-col gap-16 py-10">
      <div className="flex flex-col max-sm:w-full max-md:w-full max-lg:w-full w-6/12 gap-5 item-center shadow-lg p-8 bg-white rounded-lg">
        <h1 className="text-2xl font-semibold opacity-80 text-main-orange ">
          Contact Akerayu: Get Help & Share Feedback
        </h1>
        <p className="text-base opacity-80  font-semibold">
          Contact us for any assistance and feedback. Our support team is
          available for technical issues, listing problems, and general
          inquiries. We value your suggestions for improvement.
        </p>

        <TextField
          required
          id="outlined"
          label="Your Name"
          placeholder="Name"
          name="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          required
          id="outlined-required"
          label="Your Email"
          placeholder="Email"
          value={email}
          name="email"
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextField
          id="outlined-textarea"
          label="Your Message"
          placeholder="Message"
          name="message"
          value={userMessage}
          multiline
          rows={4}
          onChange={(e) => setUserMessage(e.target.value)}
        />
        <button
          className=" bg-main-orange flex flex-row items-center m-auto justify-center w-32 py-2 px-4 text-white rounded-lg font-medium"
          onClick={formSubmit}
        >
          Send <AiOutlineSend className="pl-2 text-3xl" />
        </button>
      </div>
      <div className="w-4/12 max-sm:w-full max-md:w-full max-lg:w-full">
        <div className="flex flex-col gap-6">
          <div className="m-auto  overflow-hidden">
            <svg
              version="1.0"
              xmlns="http://www.w3.org/2000/svg"
              width="300.000000pt"
              height="278.000000pt"
              viewBox="0 0 300.000000 278.000000"
              preserveAspectRatio="xMidYMid meet"
            >
              <g
                transform="translate(0.000000,278.000000) scale(0.050000,-0.050000)"
                fill="#3b82f6"
                stroke="none"
              >
                {" "}
                <path d="M4100 5074 c0 -14 11 -37 24 -50 19 -19 19 -24 0 -24 -13 0 -24 -12 -24 -27 0 -19 25 -28 77 -28 77 0 78 1 78 78 0 79 -26 98 -71 53 -19 -19 -24 -19 -24 0 0 13 -13 24 -30 24 -16 0 -30 -12 -30 -26z" />{" "}
                <path d="M4284 4776 c-57 -57 -1 -151 75 -126 68 21 43 150 -29 150 -12 0 -33 -11 -46 -24z" />{" "}
                <path d="M3020 4740 c-51 -51 -53 -162 -3 -207 54 -49 174 -43 212 11 71 102 9 236 -109 236 -33 0 -78 -18 -100 -40z m150 -100 c0 -40 -11 -51 -55 -56 -55 -7 -82 63 -41 104 33 33 96 2 96 -48z" />{" "}
                <path d="M4904 4568 c-10 -18 -14 -50 -9 -71 8 -31 -2 -37 -63 -37 -58 0 -72 -8 -72 -39 0 -47 65 -71 118 -42 36 19 38 16 23 -36 -19 -66 8 -126 50 -110 18 7 29 38 29 80 0 60 5 67 45 57 58 -13 104 17 89 58 -8 19 -36 32 -72 32 -52 0 -60 8 -66 63 -7 73 -44 96 -72 45z" />{" "}
                <path d="M2032 4452 c-232 -86 -360 -400 -240 -587 l29 -45 -371 0 c-475 0 -450 19 -450 -336 0 -359 -16 -344 361 -344 l299 0 100 -72 100 -72 0 71 c0 69 2 71 85 77 119 9 140 56 127 286 l-10 180 124 0 c94 0 143 11 203 46 43 26 94 43 113 38 24 -6 32 -1 25 18 -6 15 12 74 41 132 177 354 -167 744 -536 608z m154 -221 c35 -8 71 -37 95 -78 22 -37 62 -77 89 -89 66 -31 63 -74 -7 -103 -108 -45 -306 -177 -285 -190 12 -7 21 -42 20 -77 l-2 -64 -20 70 c-29 102 -51 120 -148 120 -74 0 -130 35 -68 43 11 1 31 4 45 6 14 3 54 -12 90 -32 l65 -36 0 78 c0 43 -15 104 -34 137 -30 53 -31 69 -6 147 37 118 37 119 76 98 19 -10 59 -24 90 -30z m154 -369 c0 -45 -42 -66 -82 -40 -23 16 -21 24 11 48 52 40 71 38 71 -8z m-1021 -331 c54 -65 -45 -164 -110 -110 -36 29 -38 112 -4 126 47 19 90 13 114 -16z m282 -13 c19 -36 16 -50 -19 -85 -65 -65 -149 7 -114 98 17 45 107 35 133 -13z m247 30 c40 -15 42 -95 3 -127 -64 -54 -151 25 -110 100 21 40 52 48 107 27z" />{" "}
                <path d="M1151 4409 c-77 -78 13 -220 107 -170 69 37 90 96 53 152 -37 57 -112 65 -160 18z" />{" "}
                <path d="M2835 4246 c-56 -9 -71 -34 -35 -56 11 -7 20 -5 20 4 0 10 68 19 150 21 93 3 150 -4 150 -17 0 -11 19 -7 42 9 43 30 96 24 123 -16 9 -14 14 -12 15 5 0 15 10 20 24 12 13 -9 42 -17 65 -20 124 -13 201 -32 213 -50 7 -12 16 -20 20 -18 23 10 116 -27 107 -42 -6 -10 12 -18 40 -18 28 0 51 -10 51 -21 0 -12 8 -16 18 -10 17 10 125 -63 139 -94 3 -8 14 -11 22 -5 20 12 173 -108 166 -132 -2 -9 8 -12 23 -6 16 6 46 -16 72 -52 25 -35 75 -96 111 -136 37 -39 61 -80 55 -91 -7 -11 -3 -13 9 -6 12 7 26 2 31 -12 4 -14 15 -19 24 -11 43 41 -270 368 -493 514 -311 203 -786 305 -1162 248z" />{" "}
                <path d="M3280 3940 c-26 -17 -91 -22 -285 -20 -19 0 -46 1 -60 1 -46 3 -135 -14 -148 -28 -8 -7 134 -12 315 -11 180 2 312 7 293 12 -20 5 -31 17 -25 26 5 9 -9 11 -33 5 -30 -8 -39 -4 -29 12 17 28 11 29 -28 3z" />{" "}
                <path d="M3480 3746 c0 -201 69 -266 283 -266 122 0 130 -18 -93 204 l-190 190 0 -128z" />{" "}
                <path d="M2613 3647 c-55 -56 -7 -67 294 -67 313 0 349 6 310 53 -23 29 -576 41 -604 14z" />{" "}
                <path d="M5360 3614 c0 -14 10 -36 22 -48 15 -15 15 -25 0 -35 -44 -27 -20 -46 58 -46 78 0 102 19 59 46 -14 9 -14 21 2 40 32 39 4 78 -34 47 -22 -18 -34 -19 -52 -1 -30 30 -55 29 -55 -3z" />{" "}
                <path d="M4545 3293 c-255 -134 -465 -252 -465 -264 0 -11 60 -40 134 -64 l133 -44 102 88 c55 48 171 147 256 220 201 174 195 155 -35 -114 -105 -123 -184 -229 -175 -236 26 -23 405 -146 416 -135 19 19 127 766 113 779 -8 7 -223 -96 -479 -230z" />{" "}
                <path d="M2614 3507 c-52 -52 -8 -67 197 -67 191 0 211 3 205 35 -7 36 -369 66 -402 32z" />{" "}
                <path d="M2358 3445 c-1 -19 -1 -84 0 -144 1 -67 -7 -114 -23 -124 -19 -13 -19 -16 2 -17 24 0 24 -5 0 -34 -22 -28 -22 -31 0 -17 22 13 25 0 18 -62 -5 -43 -2 -96 7 -117 8 -22 15 93 15 255 0 245 -11 395 -19 260z" />{" "}
                <path d="M3879 3328 c-1 -43 -4 -126 -5 -185 -2 -59 3 -117 11 -130 16 -25 20 26 17 235 -2 148 -21 212 -23 80z" />{" "}
                <path d="M5120 3245 c-1 -47 -79 -691 -85 -697 -3 -3 -49 9 -100 28 -100 36 -172 13 -120 -39 40 -40 305 -120 305 -91 0 3 18 162 40 355 51 446 51 459 0 459 -22 0 -40 -7 -40 -15z" />{" "}
                <path d="M2604 3205 c10 -54 1022 -54 1032 0 6 33 -29 35 -516 35 -487 0 -522 -2 -516 -35z" />{" "}
                <path d="M221 3131 c-53 -64 25 -162 94 -119 48 30 54 77 15 116 -41 40 -78 41 -109 3z" />{" "}
                <path d="M2604 3065 c9 -50 946 -55 946 -5 0 26 -69 31 -477 35 -446 5 -476 4 -469 -30z" />{" "}
                <path d="M2604 2925 c10 -54 1022 -54 1032 0 6 33 -29 35 -516 35 -487 0 -522 -2 -516 -35z" />{" "}
                <path d="M1429 2836 c-65 -365 44 -855 262 -1188 78 -118 376 -428 412 -428 10 0 37 -17 60 -39 23 -21 109 -71 192 -111 929 -453 2020 21 2348 1020 46 139 71 330 44 330 -10 0 -21 -28 -23 -62 -3 -34 -15 -82 -28 -105 -21 -39 -35 -95 -41 -168 -1 -14 -9 -25 -18 -25 -9 0 -10 -15 -3 -33 9 -24 6 -29 -14 -17 -17 11 -21 8 -12 -7 20 -33 -76 -235 -126 -267 -23 -14 -42 -40 -42 -57 0 -46 -115 -198 -218 -290 -49 -44 -115 -104 -147 -134 -33 -30 -67 -50 -77 -44 -10 6 -18 4 -18 -5 0 -18 -96 -73 -185 -105 -30 -11 -55 -27 -55 -36 0 -9 -19 -18 -41 -20 -23 -1 -81 -18 -130 -36 -48 -19 -106 -29 -128 -23 -23 5 -37 3 -31 -5 16 -27 -157 -40 -188 -15 -23 19 -26 19 -15 -1 11 -17 1 -25 -32 -25 -26 0 -59 11 -74 25 -20 18 -23 18 -13 1 18 -33 -352 -11 -408 24 -16 10 -55 20 -88 24 -33 4 -76 21 -96 39 -23 21 -36 25 -36 9 0 -17 -7 -17 -28 2 -20 19 -21 30 -5 43 14 10 5 13 -22 7 -42 -10 -233 89 -305 158 -16 16 -51 47 -77 68 -26 21 -43 51 -37 66 5 15 -2 27 -17 27 -15 0 -22 -9 -16 -21 13 -28 -87 85 -153 171 -27 36 -48 73 -45 81 3 9 -9 16 -27 16 -20 0 -28 11 -21 30 7 17 5 30 -4 30 -16 0 -103 143 -103 169 0 7 11 7 25 -1 14 -8 5 8 -20 35 -25 27 -45 65 -45 84 0 23 -9 30 -25 21 -20 -11 -20 -8 0 13 29 31 34 67 7 50 -24 -14 -50 100 -30 132 8 13 6 18 -6 10 -32 -19 -48 128 -45 403 4 261 -7 322 -32 180z" />{" "}
                <path d="M1034 2867 c-8 -7 -4 -25 9 -40 16 -20 15 -35 -3 -57 -34 -42 -8 -64 40 -35 24 15 43 17 50 5 26 -42 45 -17 45 60 0 83 -11 96 -49 58 -15 -15 -25 -15 -35 0 -15 25 -38 28 -57 9z" />{" "}
                <path d="M4420 2743 c0 -129 31 -148 102 -61 70 84 72 110 10 126 -27 6 -63 17 -80 24 -27 10 -32 -5 -32 -89z" />{" "}
                <path d="M2276 2692 l-95 -102 0 -546 -1 -546 49 -49 49 -49 847 0 c733 0 852 4 891 31 44 31 44 35 44 606 l0 575 -100 98 -100 98 0 -171 0 -172 -338 -212 c-421 -266 -369 -266 -799 2 l-344 215 3 155 c5 193 8 191 -106 67z m15 -164 c27 -18 49 -49 49 -69 0 -70 -39 -60 -80 20 -45 90 -41 96 31 49z m1729 5 c0 -15 -18 -48 -40 -73 -22 -25 -41 -56 -41 -68 -1 -12 -10 0 -21 28 -18 43 -13 56 36 95 66 53 66 53 66 18z m-1602 -253 c12 0 22 -10 22 -22 0 -12 14 -17 30 -11 17 7 30 1 30 -14 0 -26 95 -84 125 -76 8 1 15 -7 15 -19 0 -14 19 -18 49 -10 27 7 54 4 60 -7 7 -11 27 -14 44 -7 26 10 29 5 14 -20 -21 -39 -506 -574 -520 -574 -15 0 5 192 24 222 10 15 15 44 12 63 -3 19 6 35 21 35 19 1 18 6 -4 20 -16 11 -22 20 -13 20 10 0 7 14 -7 30 -14 17 -16 30 -6 30 24 0 22 79 -3 118 -10 17 -10 24 1 17 10 -6 17 55 16 140 -2 148 -1 151 33 108 20 -23 45 -43 57 -43z m1522 -11 c0 -42 -10 -69 -25 -69 -18 -1 -19 -5 -2 -15 14 -10 22 -82 22 -195 -1 -164 11 -302 37 -427 14 -67 -2 -53 -282 249 -223 241 -282 317 -235 304 8 -2 51 4 95 13 44 10 87 19 96 19 8 1 23 15 33 30 10 17 34 23 60 16 34 -8 39 -5 22 15 -16 20 -14 29 10 38 20 8 27 4 19 -12 -7 -14 7 -2 31 25 24 28 57 47 74 43 21 -4 27 4 18 27 -7 19 -4 27 7 20 11 -7 20 -43 20 -81z m-1040 -351 c0 -10 16 -18 35 -18 30 1 31 3 5 20 -34 22 -19 26 28 8 18 -7 27 -20 22 -29 -6 -9 -2 -22 10 -29 11 -7 20 -4 20 5 0 10 13 18 29 18 16 0 25 -7 19 -16 -6 -9 9 -17 32 -17 23 0 38 8 32 17 -6 9 3 16 19 16 16 0 29 -7 29 -16 0 -9 14 -11 30 -4 17 6 30 23 30 37 0 16 15 22 40 16 26 -7 40 -1 40 17 1 23 3 23 18 0 12 -19 21 -21 31 -5 20 33 51 26 51 -11 0 -19 6 -28 13 -21 7 7 30 -10 51 -37 21 -27 51 -49 65 -49 26 0 61 -55 54 -85 -2 -8 12 -15 30 -15 19 0 28 -6 20 -13 -7 -8 12 -30 42 -50 54 -36 54 -37 9 -37 -26 0 -41 -8 -35 -18 6 -10 -11 -16 -38 -13 -27 3 -54 -7 -59 -22 -6 -15 -21 -27 -33 -27 -12 0 -16 8 -10 18 6 10 -3 23 -19 29 -16 6 -29 5 -27 -3 6 -39 -6 -46 -37 -21 -22 18 -29 19 -19 2 10 -17 5 -21 -16 -13 -17 7 -26 20 -20 30 6 10 2 18 -10 18 -11 0 -21 -16 -22 -35 0 -29 -7 -27 -40 12 -21 26 -39 39 -39 29 0 -10 -36 -17 -79 -15 -51 3 -78 -3 -75 -18 2 -15 -34 -24 -99 -26 -81 -2 -102 4 -93 25 6 16 0 28 -12 28 -12 0 -22 -12 -22 -26 0 -14 -22 -26 -50 -26 -53 0 -67 22 -25 39 16 6 13 10 -8 11 -18 1 -38 -11 -44 -28 -17 -44 -80 -39 -65 5 11 31 9 32 -13 3 -32 -40 -77 -27 -60 18 12 30 7 30 -43 -3 -31 -20 -51 -28 -44 -16 7 11 4 26 -7 33 -27 16 31 88 126 158 29 20 48 44 42 53 -5 9 9 22 31 29 23 7 55 34 72 60 29 44 88 49 88 8z m410 -362 c6 -6 -30 -12 -80 -13 -50 -1 -87 6 -81 15 11 18 143 17 161 -2z" />{" "}
                <path d="M2604 2725 c9 -49 806 -55 806 -5 0 26 -61 31 -407 35 -379 5 -406 4 -399 -30z" />{" "}
                <path d="M2604 2585 c10 -54 1022 -54 1032 0 6 33 -29 35 -516 35 -487 0 -522 -2 -516 -35z" />{" "}
                <path d="M700 2260 c-87 -87 12 -238 120 -180 112 60 83 220 -40 220 -22 0 -58 -18 -80 -40z m111 -62 c21 -33 -26 -71 -53 -44 -23 23 -9 66 22 66 10 0 24 -10 31 -22z" />{" "}
                <path d="M5231 2189 c-47 -48 -39 -123 18 -160 62 -41 127 -22 153 45 40 107 -91 195 -171 115z" />{" "}
                <path d="M280 1560 c-125 -125 49 -311 196 -209 57 40 61 167 7 216 -50 45 -154 42 -203 -7z m166 -65 c14 -41 -24 -95 -67 -95 -45 0 -70 44 -52 90 14 36 106 40 119 5z" />{" "}
                <path d="M5347 1380 c-104 -42 -140 -193 -67 -286 74 -94 202 -88 285 13 112 139 -49 341 -218 273z m136 -93 c89 -80 -9 -223 -114 -167 -37 20 -49 43 -49 92 0 99 91 141 163 75z" />{" "}
                <path d="M1496 1289 c-93 -205 619 -743 934 -706 111 13 123 166 15 187 -326 65 -546 199 -721 440 -110 151 -184 176 -228 79z" />{" "}
                <path d="M1041 1251 c-32 -38 -9 -106 41 -122 75 -24 130 71 74 127 -33 33 -86 30 -115 -5z" />{" "}
                <path d="M4260 1114 c0 -14 10 -36 22 -48 15 -15 14 -33 -5 -63 -32 -52 -7 -79 44 -47 31 19 47 19 78 0 50 -32 77 -5 45 45 -19 31 -19 47 0 78 32 51 5 76 -47 44 -30 -19 -48 -20 -63 -5 -30 30 -74 28 -74 -4z" />{" "}
                <path d="M1387 1050 c-17 -46 9 -94 48 -86 43 8 58 75 22 98 -39 25 -57 22 -70 -12z" />{" "}
                <path d="M1420 563 c0 -43 9 -53 49 -53 39 0 48 10 47 53 -3 77 -96 77 -96 0z" />{" "}
                <path d="M3080 392 c0 -15 -19 -32 -42 -38 -45 -12 -35 -54 13 -54 16 0 29 -13 29 -29 0 -47 42 -58 53 -15 6 22 29 45 51 51 43 11 32 53 -15 53 -16 0 -29 14 -29 30 0 17 -13 30 -30 30 -16 0 -30 -12 -30 -28z" />{" "}
              </g>
            </svg>
          </div>
          <div className="flex flex-row justify-center w-full ">
            {/* <div className="flex flex-row gap-2 text-lg items-center m-auto w-48">
              <FiPhoneCall className="text-xl" /> <span>+1 98 765 4321</span>
            </div> */}
            <div className="flex flex-row gap-2 text-lg justify-center items-center w-48">
              <AiOutlineMail className="text-xl" />
              <span
                className=" cursor-pointer font-bold"
                onClick={() => window.open("mailto:support@akerayu.com")}
              >
                support@akerayu.com
              </span>
            </div>
          </div>
          <div className="flex flex-row justify-center gap-4 ">
            <div className="flex gap-2  text-3xl">
              <a
                href="https://www.tiktok.com/@akerayuofficial"
                data-scheme="tg://resolve?domain=akerayu"
                target="_blank"
                rel="noreferrer"
                className="p-1 rounded-lg bg-slate-200 text-black "
              >
                <AiFillTikTok />
              </a>
              <a
                href="https://t.me/akerayu"
                data-scheme="tg://resolve?domain=akerayu"
                target="_blank"
                rel="noreferrer"
                className="p-1 rounded-lg bg-slate-200 text-[#0088cc]"
              >
                <FaTelegram />
              </a>
              <a
                href="https://www.instagram.com/akerayu"
                data-scheme="instagram://user?username=akerayu"
                target="_blank"
                rel="noreferrer"
                className="p-1 rounded-lg bg-slate-200 text-[#fb3958]"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.facebook.com/akerayuofficial"
                data-scheme="fb://profile/akerayuofficial"
                target="_blank"
                rel="noreferrer"
                className="p-1 rounded-lg bg-slate-200 text-[#4267B2]"
              >
                <FaFacebookSquare />
              </a>
              <a
                href="https://twitter.com/akerayuofficial"
                data-scheme="twitter://user?screen_name=akerayuofficial"
                target="_blank"
                rel="noreferrer"
                className="p-1 rounded-lg bg-slate-200 text-[#00acee]"
              >
                <FaTwitter />
              </a>
              <a
                href="https://www.linkedin.com/company/akerayu"
                data-scheme="linkedin://company/akerayu"
                target="_blank"
                rel="noreferrer"
                className="p-1 rounded-lg bg-slate-200 text-[#0077B5]
]"
              >
                <FaLinkedin />
              </a>
              <a
                href="https://www.youtube.com/@Akerayu"
                data-scheme="youtube://www.youtube.com/@Akerayu"
                target="_blank"
                rel="noreferrer"
                className="p-1 rounded-lg bg-slate-200 text-[#FF0000]"
              >
                <TiSocialYoutube />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUsCard;
